
namespace Matrix.Exceptions {

    /**
     * Checks if the date is in the past.
     * Converts today and paramter to "yyyy-MM-dd-HH-mm-ss" format.
     * @returns {true} if date is in the past.
     * @returns {false} if date is today or in the future.
     */
    export function isDateTimeInPast(date: string | Date): boolean {
        return Q.formatDate(date, "yyyy-MM-dd-HH-mm-ss") < Q.formatDate(new Date(), "yyyy-MM-dd-HH-mm-ss");
    };

    export interface IExceptionInboxIgnoringRequest {
        EntityId: number;
        IgnoredUntil?: string;
    }

    @Serenity.Decorators.registerClass()
    export class ExceptionInboxIgnoringDialog extends Serenity.PropertyDialog<ExceptionRow, any> {

        private form: ExceptionInboxIgnoringForm = new ExceptionInboxIgnoringForm(this.idPrefix);

        constructor() {
            super();

            this.dialogTitle = "Ignore Exception";
            this.form.IgnoredUntil.addValidationRule(this.uniqueName, () => {
                if (isDateTimeInPast(this.form.IgnoredUntil.valueAsDate))
                    return "Date entered is in the past!"
            });
        }

        public execute(request: IExceptionInboxIgnoringRequest) {
            this.propertyGrid.load(request);
            this.dialogOpen();

            if (isDateTimeInPast(request.IgnoredUntil))
                return

            $('<button type="button" class="ui-button ui-corner-all ui-widget">Clear</button>').appendTo(this.element.parent().find('.ui-dialog-buttonpane')).click(() => {
                ExceptionService.Update({
                    EntityId: request.EntityId,
                    Entity: {
                        IgnoredBy: null,
                        IgnoredUntil: null,
                        IgnoredWhen: null
                    }
                },
                    _ => {
                        Q.notifySuccess("Cleared ignored until date of exception.")
                        Serenity.SubDialogHelper.triggerDataChange(this);
                        this.dialogClose();
                    });
            });
        }

        protected okClickValidated() {
            var request = this.getSaveEntity() as IExceptionInboxIgnoringRequest;
            ExceptionService.Update({
                EntityId: request.EntityId,
                Entity: {
                    IgnoredBy: Q.Authorization.username,
                    IgnoredUntil: request.IgnoredUntil,
                }
            },
                _ => {
                    Q.notifySuccess("Ignored exception.")
                    Serenity.SubDialogHelper.triggerDataChange(this);
                    this.dialogClose();
                });
        }
    }
}